import { useEffect, useState } from "react";
import { Quote, MapPin, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

export default function Stories() {
  const [stories, setStories] = useState([]);

  useEffect(() => { api.get("/stories").then((r) => setStories(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="stories-page">
      <section className="section-pad container-luxe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="overline">Success Stories</p>
            <h1 className="font-display text-5xl md:text-6xl text-aubergine mt-6 leading-tight">
              Quiet beginnings. <em className="text-rose not-italic">Loud results.</em>
            </h1>
          </div>
        </div>

        <div className="mt-16 space-y-24">
          {stories.map((s, i) => (
            <article key={s.id} data-testid={`story-${s.id}`} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
              <div className="lg:col-span-5 [direction:ltr]">
                <div className="relative">
                  <img src={s.image} alt={s.name} className="rounded-2xl w-full h-[480px] object-cover" />
                  <div className="absolute bottom-6 left-6 right-6 bg-ivory/95 backdrop-blur p-5 rounded-xl">
                    <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-plum">
                      <TrendingUp className="w-3.5 h-3.5" />
                      <span>Outcome</span>
                    </div>
                    <p className="font-display text-3xl text-aubergine mt-1">{s.metric}</p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-6 lg:col-start-7 [direction:ltr]">
                <p className="overline flex items-center gap-2"><MapPin className="w-3 h-3" /> {s.city}</p>
                <h2 className="font-display text-4xl text-aubergine mt-3">{s.name}</h2>
                <div className="mt-8 space-y-4">
                  <div>
                    <p className="text-xs uppercase tracking-widest text-plum">Before WOWSHE</p>
                    <p className="text-plumSoft mt-1 font-light">{s.before}</p>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-plum">After WOWSHE</p>
                    <p className="text-aubergine mt-1">{s.after}</p>
                  </div>
                </div>
                <div className="mt-8 border-l-2 border-rose pl-6">
                  <Quote className="w-6 h-6 text-rose mb-3" />
                  <p className="font-display text-2xl text-aubergine leading-snug">"{s.quote}"</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
